export default "__VITE_ASSET__BeEcbfbZ__"